import apiRequest from './client';

// Utilisateurs de la company (Parametres > Utilisateurs) — compte principal
// uniquement (backend CompanyUserViewSet / IsCompanyOwner). `denied_keys` =
// pages RETIREES (tout est accorde par defaut).
export const listCompanyUsers = () => apiRequest('/company-users/');

export const getCompanyUserCatalog = () => apiRequest('/company-users/catalog/');

export const createCompanyUser = (data) =>
  apiRequest('/company-users/', { method: 'POST', body: data });

export const updateCompanyUser = (id, data) =>
  apiRequest(`/company-users/${id}/`, { method: 'PATCH', body: data });

export const deleteCompanyUser = (id) =>
  apiRequest(`/company-users/${id}/`, { method: 'DELETE' });
